import React from 'react';
import PropTypes from 'prop-types';
import 'numeral/locales/it';
import numeral from 'numeral';
import ShowComponent from '../hocs/ShowComponent';
import InformationBoxComponent from './InformationBoxComponent';
import MortageLoanpartsDifferenceToolTipComponent from './MortageLoanpartsDifferenceToolTipComponent';

numeral.locale('it');

@ShowComponent
class MortgageLoanpartsDifferenceComponent extends React.Component {
  render() {
    const {
      loanparts,
      mortgage,
      toolTipVisible,
      toggleToolTip,
      showToolTip,
      hideToolTip,
    } = this.props;

    const absoluteDifference = numeral(Math.abs(this.props.difference)).format('0,0[.]00');
    let message;

    const difference = (
      <span
        className="mortgage-loanparts-difference__info-text bold underline"
        onMouseEnter={showToolTip}
        onMouseLeave={hideToolTip}
        onClick={toggleToolTip}
      >
        € {absoluteDifference}
        <MortageLoanpartsDifferenceToolTipComponent
          loanparts={loanparts}
          mortgage={mortgage}
          show={toolTipVisible}
        />
      </span>
    );

    const defaultSuffix = 'Pas de bedragen van de leningdelen en/of uw gewenste hypotheek aan.';

    if (this.props.difference > 0) {
      message = (
        <span>
          U komt {difference} te kort. {defaultSuffix}
        </span>
      );
    } else if (this.props.difference < 0) {
      message = (
        <span>
          U heeft {difference} te teveel ingevuld. {defaultSuffix}
        </span>
      );
    }

    return (
      <div className="mortgage-loanparts-difference">
        <InformationBoxComponent classNames="mortgage-loanparts-difference-info" />
        {message}
      </div>
    );
  }
}

MortgageLoanpartsDifferenceComponent.propTypes = {
  difference: PropTypes.number,
  showToolTip: PropTypes.func,
  hideToolTip: PropTypes.func,
  toggleToolTip: PropTypes.func,
  loanparts: PropTypes.arrayOf(PropTypes.number),
  mortgage: PropTypes.number,
  toolTipVisible: PropTypes.bool,
};

MortgageLoanpartsDifferenceComponent.defaultProps = {
  difference: 0,
  showToolTip: () => {},
  hideToolTip: () => {},
  toggleToolTip: () => {},
  loanparts: [],
  mortgage: 0,
  toolTipVisible: false,
};

export default MortgageLoanpartsDifferenceComponent;
